<div class="pu-article-card-small__image">
  <img
    ptImageLoader
    [src]="article().imageUrl"
    [alt]="article().title"
  />
</div>

<div class="pu-article-card-small__container">
  <h3 class="pu-article-card-small__title">
    {{ article().title }}
  </h3>
  <p class="pu-article-card-small__published-at">
    {{ article().publishedAt | date: 'dd MMM yyyy' }}
    <span>
      {{ article().publishedAt | date: 'HH:mm' }}
    </span>
  </p>
  <p class="pu-article-card-small__category">
    {{ article().category.name }}
  </p>
</div>
